import React from 'react';
import { Camera, Sparkles, LogIn } from 'lucide-react';
import { brand } from '../mock';

export default function Hero({ onPrimary, onSecondary, plan }) {
  const title = plan?.homepageTitle || null;
  const desc = plan?.homepageText || null;
  const promo = plan?.promo || '';
  const price = plan?.price;
  return (
    <section className="relative overflow-hidden">
      <div className="hero-glow absolute inset-0 pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-6 md:px-8 pt-8 md:pt-16 pb-20 md:pb-28">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="animate-fade-up">
            <div className="inline-flex items-center gap-2 badge-pro px-3.5 py-1.5 rounded-full text-[11px] md:text-xs font-medium tracking-[0.14em] uppercase">
              <Sparkles size={13} strokeWidth={2} />
              {promo || brand.tagline}
            </div>

            {title ? (
              <h1 className="font-serif mt-6 text-[44px] leading-[1.02] sm:text-[56px] md:text-[64px] lg:text-[68px] tracking-tight text-[#f2ecdf]">
                {title}
              </h1>
            ) : (
              <h1 className="font-serif mt-6 text-[44px] leading-[1.02] sm:text-[56px] md:text-[64px] lg:text-[68px] tracking-tight text-[#f2ecdf]">
                {brand.headline.prefix}
                <span className="gold-gradient-text italic">{brand.headline.highlight}</span>
                {brand.headline.suffix}
              </h1>
            )}

            <p className="mt-6 text-[15px] md:text-[16px] leading-relaxed text-[#b8ad95] max-w-[540px]">
              {desc || brand.subheadline}
            </p>

            {price ? (
              <div className="mt-4 inline-flex items-baseline gap-2 text-[#d6af6c]">
                <span className="text-xs uppercase tracking-wider text-[#a89e87]">A partir de</span>
                <span className="font-serif text-2xl">R$ {Number(price).toFixed(2).replace('.', ',')}</span>
                <span className="text-xs text-[#7d735e]">/{plan?.days || 30} dias</span>
              </div>
            ) : null}

            <div className="mt-9 flex flex-wrap items-center gap-3">
              <button
                onClick={onPrimary}
                data-testid="landing-cta-start"
                className="btn-gold px-5 py-3 rounded-md font-medium text-sm inline-flex items-center gap-2"
              >
                <Camera size={16} strokeWidth={2.2} />
                Começar
              </button>
              <button
                onClick={onSecondary}
                data-testid="landing-cta-login"
                className="btn-outline-dark px-5 py-3 rounded-md font-medium text-sm inline-flex items-center gap-2"
              >
                <LogIn size={15} strokeWidth={2} />
                Já tenho conta
              </button>
            </div>

            <div className="mt-6 text-sm text-[#8a7f6a]">
              Exemplo de link gerado:{' '}
              <span className="link-code text-[#d6af6c]">{brand.linkExample}</span>
            </div>
          </div>

          <div className="animate-fade-up-delay-2">
            <div className="hero-image-wrap aspect-[4/5] md:aspect-[5/6] max-w-[520px] mx-auto lg:ml-auto">
              <img
                src={brand.heroImage}
                alt="Fotógrafo revisando um ensaio em galeria digital elegante"
                className="w-full h-full object-cover"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
